// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import StoreIcon from '@mui/icons-material/Store';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import BiotechIcon from '@mui/icons-material/Biotech';
import ScienceIcon from '@mui/icons-material/Science';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    StoreIcon,
    PrecisionManufacturingIcon,
    ElectricalServicesIcon,
    RequestPageIcon,
    ImportantDevicesIcon,
    AssignmentReturnedIcon,
    ListAltIcon,
    PriceCheckIcon,
    BiotechIcon,
    ScienceIcon,
    TaskAltIcon
}

// ==============================|| COMPRAS MENU ITEMS ||============================== //

const compra = {
    id: 'compra',
    title: '',
    type: 'group',
    children: [
        {
            id: 'productosMainMenu',
            title: 'Compras',
            type: 'collapse',
            icon: icoMenu.StoreIcon,
            children: [
                {
                    id: 'comprasProductos',
                    title: 'Productos',
                    type: 'collapse',
                    icon: icoMenu.PrecisionManufacturingIcon,
                    children: [
                        {
                            id: 'crear_compra_productos',
                            title: 'Crear Compra Productos',
                            type: 'item',
                            url: '/user/new-compra/0/1',
                            requestNuevaCompra: true
                        },
                        {
                            id: 'lista_compra_productos',
                            title: 'Lista Compra Productos',
                            type: 'item',
                            url: '/user/list-compra-view'
                        },        
                        {
                            id: 'lista_compra_temporal',
                            title: 'Compras Temporales',
                            type: 'item',
                            url: '/user/list-compra-temporal/1'
                        },
                        {
                            id: 'parametros_inspeccionar_recepcion',
                            title: 'Parametros a inspeccionar',
                            type: 'item',
                            url: '/user/new-recepcion-productos-inspeccion'
                        },
                        {
                            id: 'lista_recepcion_productos',
                            title: 'Lista Recepciones',
                            type: 'item',
                            url: '/user/list-recepcion-productos'
                        },
                    ]
                },
                {
                    id: 'comprasServicios',
                    title: 'Servicios',
                    type: 'collapse',
                    icon: icoMenu.ElectricalServicesIcon,
                    children: [
                        {
                            id: 'crear_compra_servicios',
                            title: 'Crear Compra Servicios',
                            type: 'item',
                            url: '/user/new-servicio/0/0',
                            requestNuevaCompra: true
                        },      
                        {
                            id: 'lista_compra_servicios',
                            title: 'Lista Compra Servicios',
                            type: 'item',
                            url: '/user/list-compra-servicios-view'
                        },      
                        {
                            id: 'lista_compra_temporal',
                            title: 'Compras Temporales',
                            type: 'item',
                            url: '/user/list-compra-temporal/0'
                        },
                    ]
                },
                {
                    id: 'ordenes_compra',
                    title: 'Orden de Compra',
                    type: 'collapse',
                    icon: icoMenu.RequestPageIcon,
                    children: [
                        {
                            id: 'crear_orden_compra',
                            title: 'Crear Orden Compra',
                            type: 'item',
                            url: '/user/new-orden-compra/0'
                        },
                        {
                            id: 'lista_ordenes_compra',
                            title: 'Lista Ordenes Compra',
                            type: 'item',
                            url: '/user/list-orden-compra-view'
                        },
                        {
                            id: 'lista_ordenes_compra_temporales',
                            title: 'Ordenes Compra Temporales',
                            type: 'item',
                            url: '/user/list-orden-compra-temporal-view'
                        },
                    ]
                },
                {
                    id: 'comprasActivosFijos',
                    title: 'Activos Fijos',
                    type: 'collapse',
                    icon: icoMenu.ImportantDevicesIcon,
                    children: [
                        {
                            id: 'crear_compra_activos_fijos',
                            title: 'Crear Compra Activos Fijos',
                            type: 'item',
                            url: '/user/new-compra-activos-fijos/0/1'
                        },
                        {
                            id: 'lista_compra_activos_fijos',
                            title: 'Lista Compra Activos Fijos',
                            type: 'item',
                            url: '/user/list-compra-activos-fijos'
                        }
                    ]
                },
                {
                    id: 'devoluccionesComprasLote',
                    title: 'Devoluciones Compras Lote',
                    icon: icoMenu.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/busqueda-devoluciones-compras-lote'
                },
                {
                    id: 'devoluccionesCompras',
                    title: 'Devoluciones y Descuentos en Compras',
                    icon: icoMenu.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/devoluciones-compras/0'
                },
                {
                    id: 'listDevoluccionesCompras',
                    title: 'Lista Devoluciones Compras',
                    icon: icoMenu.ListAltIcon,
                    type: 'item',
                    url: '/user/list-devoluciones-compras'
                },
                {
                    id: 'corregirDatosCompra',
                    title: 'Corregir N° / Autorización Compras',
                    icon: icoMenu.TaskAltIcon,
                    type: 'item',
                    url: '/user/corregir-datos-compra'
                },
                {
                    id: 'devolucionesComprasMigrada',
                    title: 'Anulación compra sistema anterior',
                    icon: icoMenu.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/devoluciones-compras-migrada'
                },
                {
                    id: 'direccionTecnica',
                    title: 'Dirección Técnica',
                    type: 'collapse',
                    icon: icoMenu.ScienceIcon,
                    children: [
                        {
                            id: 'informeProductosCuarentena',
                            title: 'Informe de productos en Cuarentena',
                            type: 'item',
                            url: '/user/informe-productos-cuarentena'
                        },
                        {
                            id: 'listInformesProductosAprobadosRechazados',
                            title: 'Lista informes productos aprobados rechazados',
                            type: 'item',
                            url: '/user/list-informes-productos-aprobados-rechazados'
                        },
                        {
                            id: 'aprobarProductos',
                            title: 'Aprobar Productos',
                            type: 'item',
                            url: '/user/list-compras-aprobar'
                        }
                    ]
                },
            ]
        }
    ]
};

export default compra;
